import {
  app
} from './app'

// i18n case conversion tools
// eslint-disable-next-line no-extend-native
String.prototype.tTitle = function () {
  if (this === '') {
    return this
  }
  let lang = app.$store.state.lang
  // return this[0].toLocaleUpperCase(lang) + this.slice(1)
  return this[0].toUpperCase() + this.slice(1)
}
// eslint-disable-next-line no-extend-native
String.prototype.tUpper = function () {
  if (this === '') {
    return this
  }
  let lang = app.$store.state.lang
  // return this.toLocaleUpperCase(lang)
  return this.toUpperCase()
}
// eslint-disable-next-line no-extend-native
String.prototype.tCapitalizeFirstLetter = function () {
  if (this === '') {
    return this
  }
  let lang = app.$store.state.lang
  return this.toLowerCase(lang)
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
// eslint-disable-next-line no-extend-native
String.prototype.tLower = function () {
  if (this === '') {
    return this
  }
  let lang = app.$store.state.lang
  // return this.toLocaleLowerCase(lang)
  return this.toLowerCase()
}

app.$mount('#app')



// WEBPACK FOOTER //
// ./src/index.js